import React from "react"
import { Icon } from "@iconify/react"
import AutoML from "./automl.svg"
import SageMaker from "./sagemaker.svg"
import HuggingFace from "./huggingface.svg"
import Mockito from "./mockito.png"
import AwsCdk from "./awscdk.png"
import SpringBoot from "./springboot.png"
import R from "./r.png"
import Pandas from "./pandas.png"
import Makefile from "./makefile.png"
import SwiftUI from "./swiftui.png"

const svg = {
  "AWS SageMaker": SageMaker,
  "GCP AutoML": AutoML,
  "Hugging Face": HuggingFace,
}

const svgGenerator = (iconName, isCustom) => {
  if (!isCustom) {
    return <Icon icon={iconName} data-inline="false" color="black" />
  }

  if (iconName === "Mockito") {
    return <img src={Mockito} alt={iconName} width={54} />
  }

  if (iconName === "AwsCdk") {
    return <img src={AwsCdk} alt={iconName} width={42} />
  }

  if (iconName === "SpringBoot") {
    return <img src={SpringBoot} alt={iconName} width={40} />
  }

  if (iconName === "Pandas") {
    return <img src={Pandas} alt={iconName} width={36} />
  }

  if (iconName === "R") {
    return <img src={R} alt={iconName} width={40} />
  }

  if (iconName === "Makefile") {
    return <img src={Makefile} alt={iconName} width={60} />
  }

  if (iconName === "swiftui") {
    return <img src={SwiftUI} alt={iconName} width={40} />
  }

  return <img src={svg[iconName]} alt={iconName} />
}

export default svgGenerator
